import React from 'react';
import {Modal, ModalProps} from '@mantine/core';

export const EtroModalRoot: React.FC<Omit<ModalProps, 'title'>> = props => {
  return <Modal.Root {...props} />;
};
